export default __webpack_public_path__ + "static/pause-acdc8729d0098f982f7417886cbe2a1f.svg";